const BAD_GATEWAY_STATUS = 502

export const shouldRedirectBadGateway = (
  status: number | undefined,
  handleLocally = false,
): boolean => status === BAD_GATEWAY_STATUS && !handleLocally
